export const breakpoints = {
	values: {
		sm: 0,
		md: 1440,
		lg: 1919,
	},
};
